import axios from 'axios';
import { URI_ORGANISATIONS } from '../helpers/constans';
import {
  IOrganisationAccess,
  IOrganisationAccessUpdatePayload,
  IOrganisationGetResponseOk,
  IOrganisationPayload,
  IOrganisationPutResponseOk,
  IOrganisationTeamsResponse,
  TOrganisationGetAllPayload,
} from '../types/@organisation';

export const fetchOrganisationGet = (
  page: TOrganisationGetAllPayload
): Promise<IOrganisationGetResponseOk> => {
  return axios.get(`${URI_ORGANISATIONS}?page=${page}`);
};

export const fetchOrganisationPut = (payload: IOrganisationPayload): Promise<IOrganisationPutResponseOk> => {
  return axios.post(URI_ORGANISATIONS, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const fetchOrganisationAccessGet = (id: string): Promise<IOrganisationAccess> => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/access`);
};

export const fetchOrganisationTeamsGet = (id: string): Promise<IOrganisationTeamsResponse> => {
  return axios.get(`${URI_ORGANISATIONS}/${id}/teams`);
};

export const fetchOrganisationAccessPut = (
  id: string,
  payload: IOrganisationAccessUpdatePayload
): Promise<IOrganisationAccess> => {
  return axios.put(`${URI_ORGANISATIONS}/${id}/access`, payload);
};

export const fetchOrganisationRemoveMember = (id: string, userId: string): Promise<{ successful: boolean }> => {
  return axios.delete(`${URI_ORGANISATIONS}/${id}/membership/${userId}`);
};

export const fetchOrganisationLeave = (id: string): Promise<{ successful: boolean }> => {
  return axios.delete(`${URI_ORGANISATIONS}/${id}/membership/me`);
};